import type { ModuleLecturerResponseVersionHistory } from '@/common/api/models/moduleLecturerResponseVersionHistory';

export type EventKindStickyInput = {
  /** Persisted event kind on the logical task (not an in-form draft value). */
  savedEventKindId?: string | null;
  /** Selected module version workflow state, e.g. `published`. */
  moduleWorkflowState?: string;
  /** Version list available in the module editor. */
  versionHistory?: ModuleLecturerResponseVersionHistory | null;
};

/**
 * Frontend approximation of backend D1 stickiness (no dedicated API field).
 * Kind is locked when the task already has a saved kind and the module is
 * published or has more than one version in the editor.
 */
export function isEventKindSticky({
  savedEventKindId,
  moduleWorkflowState,
  versionHistory,
}: EventKindStickyInput): boolean {
  if (!savedEventKindId) {
    return false;
  }

  if (moduleWorkflowState === 'published') {
    return true;
  }

  if (!versionHistory) {
    return false;
  }

  const versionCount = Array.isArray(versionHistory)
    ? versionHistory.length
    : Object.keys(versionHistory).length;

  return versionCount > 1;
}

export const EVENT_KIND_IMMUTABLE_ERROR_CODE = 'EVENT_KIND_IMMUTABLE';
